import { Component, Input } from '@angular/core';
import {PrimaryButtonComponent} from "@cybfed/shared/components/primary-button/primary-button.component";
import {TranslateModule} from "@ngx-translate/core";
import {BannerModel} from "@white-label/components/page-builder/models/banner.model";
import {RouterModule} from "@angular/router";
import {ButtonComponent} from "@white-label/components/white-label/button/button.component";
import {VideoPlayerComponent} from "@white-label/components/white-label/video-player/video-player.component";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {IconDiscord} from "../../../../../../../../../shared/assets/icons/ts/icon-discord";
import {IconFb} from "../../../../../../../../../shared/assets/icons/ts/icon-fb";
import {IconInstagram} from "../../../../../../../../../shared/assets/icons/ts/icon-instagram";
import {IconTelegram} from "../../../../../../../../../shared/assets/icons/ts/icon-telegram";
import {IconTiktok} from "../../../../../../../../../shared/assets/icons/ts/icon-tiktok";
import {IconTwitch} from "../../../../../../../../../shared/assets/icons/ts/icon-twitch";
import {IconX} from "../../../../../../../../../shared/assets/icons/ts/icon-x";
import {IconYoutube} from "../../../../../../../../../shared/assets/icons/ts/icon-youtube";
import {HeaderStatsBannerModel} from "@white-label/components/page-builder/models/header-stats-banner.model";
import {JsonPipe} from "@angular/common";
import {HeaderLiveBannerModel} from "@white-label/components/page-builder/models/header-live-banner.model";

@Component({
    selector: 'app-hero-banner-live-stream',
    standalone: true,
    imports: [
        PrimaryButtonComponent,
        TranslateModule,
        RouterModule,
        ButtonComponent,
        VideoPlayerComponent,
        IconDiscord,
        IconFb,
        IconInstagram,
        IconTelegram,
        IconTiktok,
        IconTwitch,
        IconX,
        IconYoutube,
        JsonPipe
    ],
    providers: [],
    templateUrl: './hero-banner-live-stream.component.html'
})
export class HeroBannerLiveStreamComponent {
    @Input() componentModel: HeaderLiveBannerModel = new HeaderLiveBannerModel();
    @Input() section: any
    constructor(public mainStore: MainStoreService) {
        console.log('section', this.section)
    }

    formatNumber(value: number): string {
        if (value >= 1000000) {
            return (value / 1000000).toFixed(1) + 'M+';
        } else if (value >= 1000) {
            return (value / 1000).toFixed(1) + 'K+';
        }
        return value?value.toString(): '0';
    }
}
